/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule }     from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class ContasRoutingModule {}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/contas-routing.module.ts
 **/